import React, {PureComponent } from 'react';
import {convertOverTime} from '../Core/date';
class TimeLineLabel extends PureComponent {
    constructor(props){
        super(props);
    }
    render() {
        let {listBlock} = this.props;
        return Object.keys(listBlock).map(e => <div key={e} className="timeline-label-item">{convertOverTime(listBlock[e])}</div>)
    }
}


export default TimeLineLabel;